import { render } from "./BasketUpsells.vue?vue&type=template&id=50323053&scoped=true"
import script from "./BasketUpsells.vue?vue&type=script&lang=js"
export * from "./BasketUpsells.vue?vue&type=script&lang=js"

import "./BasketUpsells.vue?vue&type=style&index=0&id=50323053&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50323053"]])

export default __exports__